import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

homePageStyles.page = {
    css: css`
    ${GridWrapper} {
        ${GridOffset} {
            width: 100%;
            margin: 0px;
        }
    }
    `,
};